import createPlotlyComponent from "react-plotlyjs";
import React, { PureComponent } from "react";
import Plotly from "plotly.js/dist/plotly-basic";
import moment from "moment";
import _ from 'lodash';

import styled from "styled-components";

export const Wrapper = styled.div`
  &&& {
    .js-plotly-plot {
      margin-bottom: 70px;
    }
    .svg-container {
      margin: auto;
    }
    .main-svg {
      overflow: visible;
    }
    rect {
      cursor: default !important;
    }
  }
`;

const PlotlyComponent = createPlotlyComponent(Plotly);

export default class PlotlyBar extends PureComponent {
  render() {

    const x = [];
    const y = [];
    if (this.props.grouping === 'DAILY') {
      let date = moment(this.props.start);
      while (date.isSameOrBefore(this.props.end)) {
        x.push(date.format('MMMM DD, YYYY'));
        y.push(_.filter(this.props.observations, observation => {
          const obsDate = moment(observation.obsDate);
          return obsDate.format('YYYY/MM/DD') === date.format('YYYY/MM/DD');
        }).length);
        date.date(date.date() + 1);
      }
    } else {
      let date = moment(this.props.start).date(1);
      while (date.isSameOrBefore(this.props.end)) {
        x.push(date.format('MMMM YYYY'));
        y.push(_.filter(this.props.observations, observation => {
          const obsDate = moment(observation.obsDate);
          return obsDate.month() === date.month() && obsDate.year() === date.year();
        }).length);
        date.month(date.month() + 1);
      }
    }

    while (x.length < 10) {
      x.push(' '.repeat(10 - x.length));
      y.push([]);
    }

    const data = [
      {
        type: "bar",
        x,
        y,
        marker: {
          color: '#F29F5C'
        },
      },
    ];

    const layout = {
      title: this.props.grouping === 'DAILY' ? 'Daily Observation Volume' : 'Monthly Observation Volume',
      width: this.props.width,
      height: this.props.height,
      yaxis: {
        title: "Number of Observations",
        fixedrange: true,
        arraydtick: [1, 2, 5, 10],
      },
    };

    const config = {
      displayModeBar: false,
    };

    return (
      <Wrapper>
        <PlotlyComponent
          className="whatever"
          data={data}
          layout={layout}
          config={config}
        />
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/plotly/ObservationVolumeOverTime.jsx